// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"Realm__baseFont__1QFlk","container":"Realm__container__2jJ9Y","baseColor":"Realm__baseColor__K1Vew","baseFontFamily":"Realm__baseFontFamily__1fvMK"};